var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 140,
    viewBox: "0 0 143 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M111.613 34.8042H98.4116V139.217H111.613V34.8042Z",
    fill: "#233C67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.826 96.8081H52.6938V30.0452H119.939C132.579 30.0452 142.824 40.292 142.824 52.9305V96.8081H142.826Z",
    fill: "#5E9CEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.631 96.8081H30.7571V50.3669C30.7571 39.1434 39.8553 30.0452 51.0788 30.0452H54.3093C65.5328 30.0452 74.631 39.1434 74.631 50.3669V96.8081Z",
    fill: "#73B0F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8168 96.808H34.5732V52.936C34.5732 42.9272 42.6872 34.8152 52.6941 34.8152C62.7029 34.8152 70.8149 42.9291 70.8149 52.936V96.808H70.8168Z",
    fill: "#3473B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3912 35.1913C55.1973 34.9438 53.9618 34.8135 52.696 34.8135C42.6873 34.8135 34.5752 42.9274 34.5752 52.9343V96.8082H41.9675V52.9362C41.9656 44.1932 48.1545 36.8991 56.3912 35.1913Z",
    fill: "#2B69A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.826 92.04H74.6309V96.8083H142.826V92.04Z",
    fill: "#73B0F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.826 53.6504H74.6309V92.04H142.826V53.6504Z",
    fill: "#3473B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.826 53.6504H74.6309V55.5584H142.826V53.6504Z",
    fill: "#2467A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M94.9002 30.0452H92.9922V63.1886H94.9002V30.0452Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.035 20.9846H90.6079V3.81592H123.035L114.691 12.6383L123.035 20.9846Z",
    fill: "#E8553E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.708 63.4267H87.5078V3.10011C87.5078 1.38853 88.8963 0 90.6079 0C92.3195 0 93.708 1.38853 93.708 3.10011V63.4267Z",
    fill: "#27455B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9379 4.05414C88.9379 2.34256 90.3264 0.954026 92.038 0.954026C92.363 0.954026 92.6766 1.00504 92.9713 1.0976C92.4026 0.426952 91.5544 0 90.6079 0C88.8963 0 87.5078 1.38853 87.5078 3.10011V63.4267H88.9379V4.05414Z",
    fill: "#27455B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1386 3.81592H93.7085V20.9846H95.1386V3.81592Z",
    fill: "#D84435"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4888 69.3878C93.0565 69.3878 95.138 67.3063 95.138 64.7386C95.138 62.1709 93.0565 60.0894 90.4888 60.0894C87.9211 60.0894 85.8396 62.1709 85.8396 64.7386C85.8396 67.3063 87.9211 69.3878 90.4888 69.3878Z",
    fill: "#AAAAAA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2029 69.3868C93.7706 69.3868 95.8522 67.3053 95.8522 64.7376C95.8522 62.1699 93.7706 60.0884 91.2029 60.0884C88.6352 60.0884 86.5537 62.1699 86.5537 64.7376C86.5537 67.3053 88.6352 69.3868 91.2029 69.3868Z",
    fill: "#C9C9C9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3224 67.0031C92.6391 67.0031 93.7065 65.9357 93.7065 64.619C93.7065 63.3023 92.6391 62.2349 91.3224 62.2349C90.0056 62.2349 88.9382 63.3023 88.9382 64.619C88.9382 65.9357 90.0056 67.0031 91.3224 67.0031Z",
    fill: "#AAAAAA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1093 102.771H3.57618C1.60012 102.771 0 101.169 0 99.1943C0 97.2183 1.60201 95.6182 3.57618 95.6182H75.1093C77.0854 95.6182 78.6855 97.2202 78.6855 99.1943C78.6855 101.169 77.0835 102.771 75.1093 102.771Z",
    fill: "#70B2ED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.453 56.3237L50.9234 83.8771C50.8176 84.408 50.3019 84.7518 49.771 84.6441L7.34045 76.1278C6.80959 76.022 6.46576 75.5063 6.57345 74.9754L12.103 47.422C12.2088 46.8911 12.7246 46.5473 13.2554 46.655L55.686 55.1713C56.215 55.2771 56.5588 55.7929 56.453 56.3237Z",
    fill: "#FFAC27"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.3453 81.7594L50.9202 83.8752C50.8144 84.4061 50.2987 84.7499 49.7678 84.6422L7.33728 76.1259C6.80642 76.0201 6.46259 75.5044 6.57027 74.9735L6.99533 72.8577C11.6446 67.296 21.1829 64.5982 31.3145 66.631C41.4461 68.6656 49.2011 74.8356 51.3453 81.7594Z",
    fill: "#FDCD56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0673 55.0467L33.0566 70.4887C31.483 71.5372 29.3388 71.1065 28.2903 69.5328L13.8042 46.7646L55.0673 55.0467Z",
    fill: "#ED9718"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.137 55.0597L33.2246 69.646C31.651 70.6944 29.5068 70.2637 28.4583 68.69L13.8721 46.7795L55.137 55.0597Z",
    fill: "#FDCD56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.c98626869edf0b4ef0c7932c8c6883e8.svg";
export { ForwardRef as ReactComponent };